import { useRuntimeStore } from "@/store/runtime";

import info from '@/assets/audio/info.ogg';
import error from '@/assets/audio/error.ogg';
import warning from '@/assets/audio/warning.ogg';
import success from '@/assets/audio/success.ogg';
import click from '@/assets/audio/click.ogg';
import update from '@/assets/audio/update.ogg';
import startup from '@/assets/audio/startup.ogg';


const soundBoard = {
    info,
    error,
    warning,
    success,
    click,
    update,
    startup,
};
 
export const useSound = () => {
    const runtimeStore = useRuntimeStore();

    const play = (sound_slug) => {
        const result = {
            sound: null,
            message: null
        };

        const uiSoundEnabled = runtimeStore.session.settings?.uiSoundEnabled;

        if (uiSoundEnabled && Audio) {
            const sound = new Audio(soundBoard[sound_slug]);
            sound.play();
            result.sound = sound;
            result.message = `Playing sound: ${sound_slug}`;
        }

        return result;
    };

    return {
        play,
    };
};
